export enum CURRENCY_SYMBOL {
  USD = '$',
  BR = 'R$'
}
